var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          {
            staticClass: "page-header",
            attrs: { slot: "header" },
            slot: "header",
          },
          [
            _c("div", { staticClass: "header-content" }, [
              _c("div", { staticClass: "header-left" }, [
                _c("h3", { staticClass: "page-title" }, [
                  _c("i", { staticClass: "el-icon-s-shop" }),
                  _vm._v("\n             店铺管理\n           "),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "page-description" }, [
                  _vm._v(
                    "管理平台所有商户的店铺信息，包含店铺状态、营业情况及地址信息"
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "header-right" }, [
                _c("div", { staticClass: "header-stats" }, [
                  _c("div", { staticClass: "stat-card" }, [
                    _c("div", { staticClass: "stat-number" }, [
                      _vm._v(_vm._s(_vm.pagination.total)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "stat-label" }, [
                      _vm._v("总店铺数"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stat-card" }, [
                    _c("div", { staticClass: "stat-number" }, [
                      _vm._v(_vm._s(_vm.getOperatingCount())),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "stat-label" }, [
                      _vm._v("营业中"),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "search-section" },
          [
            _c("div", { staticClass: "search-header" }, [
              _c("div", { staticClass: "search-title" }, [
                _c("i", { staticClass: "el-icon-search" }),
                _vm._v("\n           筛选搜索\n         "),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "search-actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-search",
                        size: "small",
                      },
                      on: { click: _vm.handleSearch },
                    },
                    [_vm._v("\n             搜索\n           ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-refresh", size: "small" },
                      on: { click: _vm.resetFilter },
                    },
                    [_vm._v("\n             重置\n           ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "success",
                        icon: "el-icon-plus",
                        size: "small",
                      },
                      on: { click: _vm.handleAdd },
                    },
                    [_vm._v("\n             新增店铺\n           ")]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "el-form",
              {
                staticClass: "search-form",
                attrs: { inline: true, model: _vm.filterForm, size: "small" },
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 16 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "店铺名称" } },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入店铺名称",
                                clearable: "",
                                "prefix-icon": "el-icon-shop",
                              },
                              model: {
                                value: _vm.filterForm.storeName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filterForm, "storeName", $$v)
                                },
                                expression: "filterForm.storeName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "所属商户" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder: "请选择商户",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.filterForm.merchantId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filterForm, "merchantId", $$v)
                                  },
                                  expression: "filterForm.merchantId",
                                },
                              },
                              _vm._l(_vm.merchantOptions, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "店铺状态" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder: "请选择店铺状态",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.filterForm.storeStatus,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filterForm, "storeStatus", $$v)
                                  },
                                  expression: "filterForm.storeStatus",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "已开业", value: "open" },
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: {
                                    label: "筹备中",
                                    value: "preparing",
                                  },
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: { label: "已停用", value: "closed" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "营业状态" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder: "请选择营业状态",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.filterForm.businessStatus,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.filterForm,
                                      "businessStatus",
                                      $$v
                                    )
                                  },
                                  expression: "filterForm.businessStatus",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: "营业中",
                                    value: "operating",
                                  },
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: {
                                    label: "暂停营业",
                                    value: "suspended",
                                  },
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: { label: "休息中", value: "closed" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { gutter: 16 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "所在地址" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder: "请选择地区",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.filterForm.location,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filterForm, "location", $$v)
                                  },
                                  expression: "filterForm.location",
                                },
                              },
                              _vm._l(_vm.locationOptions, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "店铺类别" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: "请选择店铺类别" },
                                on: { change: _vm.handleCategoryChange },
                                model: {
                                  value: _vm.filterForm.storeCategory,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.filterForm,
                                      "storeCategory",
                                      $$v
                                    )
                                  },
                                  expression: "filterForm.storeCategory",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: "商超",
                                    value: "supermarket",
                                  },
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: { label: "酒店", value: "hotel" },
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: { label: "餐厅", value: "restaurant" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "table-section" },
          [
            _c("div", { staticClass: "table-header" }, [
              _c("div", { staticClass: "table-title" }, [
                _c("i", { staticClass: "el-icon-s-grid" }),
                _vm._v("\n           店铺列表\n         "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "table-info" }, [
                _c("span", { staticClass: "info-text" }, [
                  _vm._v("共 " + _vm._s(_vm.pagination.total) + " 家店铺"),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                staticClass: "store-table",
                attrs: {
                  data: _vm.tableData,
                  border: "",
                  stripe: "",
                  "header-cell-style": {
                    background: "#f8fafc",
                    color: "#2d3748",
                    fontWeight: "600",
                  },
                  size: "small",
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "id",
                    label: "ID",
                    width: "60",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "店铺LOGO", width: "100", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "logo-container" }, [
                            scope.row.logo
                              ? _c("div", { staticClass: "logo-wrapper" }, [
                                  _c("img", {
                                    staticClass: "store-logo",
                                    attrs: {
                                      src: scope.row.logo,
                                      alt: "店铺LOGO",
                                    },
                                  }),
                                ])
                              : _c("div", { staticClass: "no-logo" }, [
                                  _c("i", {
                                    staticClass: "el-icon-picture-outline",
                                  }),
                                ]),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "storeName",
                    label: "店铺名称",
                    "min-width": "160",
                    "show-overflow-tooltip": "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "store-name-wrapper" }, [
                            _c("i", {
                              staticClass: "el-icon-s-shop",
                              staticStyle: {
                                color: "#38b2ac",
                                "margin-right": "6px",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "store-name" }, [
                              _vm._v(_vm._s(scope.row.storeName)),
                            ]),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "merchantName",
                    label: "所属商户",
                    width: "130",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "merchant-name-wrapper" }, [
                            _c("i", {
                              staticClass: "el-icon-office-building",
                              staticStyle: {
                                color: "#4299e1",
                                "margin-right": "4px",
                              },
                            }),
                            _vm._v(
                              "\n             " +
                                _vm._s(scope.row.merchantName) +
                                "\n           "
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "address", label: "门店地址", width: "120" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "storeStatus",
                    label: "店铺状态",
                    width: "110",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            { staticClass: "status-wrapper" },
                            [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: _vm.getStoreStatusType(
                                      scope.row.storeStatus
                                    ),
                                    effect: "light",
                                    size: "small",
                                  },
                                },
                                [
                                  _c("i", {
                                    class: _vm.getStoreStatusIcon(
                                      scope.row.storeStatus
                                    ),
                                  }),
                                  _vm._v(
                                    "\n               " +
                                      _vm._s(
                                        _vm.getStoreStatusText(
                                          scope.row.storeStatus
                                        )
                                      ) +
                                      "\n             "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "businessStatus",
                    label: "营业状态",
                    width: "110",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            { staticClass: "status-wrapper" },
                            [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: _vm.getBusinessStatusType(
                                      scope.row.businessStatus
                                    ),
                                    effect: "light",
                                    size: "small",
                                  },
                                },
                                [
                                  _c("i", {
                                    class: _vm.getBusinessStatusIcon(
                                      scope.row.businessStatus
                                    ),
                                  }),
                                  _vm._v(
                                    "\n               " +
                                      _vm._s(
                                        _vm.getBusinessStatusText(
                                          scope.row.businessStatus
                                        )
                                      ) +
                                      "\n             "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "location", label: "所在地址", width: "180" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "remark",
                    label: "备注",
                    width: "120",
                    "show-overflow-tooltip": "",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "createTime",
                    label: "创建时间",
                    width: "150",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "creator",
                    label: "操作",
                    width: "80",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "操作",
                    width: "140",
                    align: "center",
                    fixed: "right",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            { staticClass: "action-buttons" },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: "编辑店铺",
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("el-button", {
                                    attrs: {
                                      type: "primary",
                                      icon: "el-icon-edit",
                                      size: "mini",
                                      circle: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleEdit(scope.row)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: "查看详情",
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("el-button", {
                                    attrs: {
                                      type: "info",
                                      icon: "el-icon-view",
                                      size: "mini",
                                      circle: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleView(scope.row)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: "删除店铺",
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("el-button", {
                                    attrs: {
                                      type: "danger",
                                      icon: "el-icon-delete",
                                      size: "mini",
                                      circle: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleDelete(scope.row)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "pagination-wrapper" },
              [
                _c("div", { staticClass: "pagination-info" }, [
                  _c("span", { staticClass: "info-text" }, [
                    _vm._v(
                      "\n             显示第 " +
                        _vm._s(
                          (_vm.pagination.page - 1) * _vm.pagination.size + 1
                        ) +
                        " - \n             " +
                        _vm._s(
                          Math.min(
                            _vm.pagination.page * _vm.pagination.size,
                            _vm.pagination.total
                          )
                        ) +
                        " 条，\n             共 " +
                        _vm._s(_vm.pagination.total) +
                        " 条记录\n           "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("el-pagination", {
                  attrs: {
                    background: "",
                    "current-page": _vm.pagination.page,
                    "page-sizes": [20, 50, 100],
                    "page-size": _vm.pagination.size,
                    total: _vm.pagination.total,
                    layout: "sizes, prev, pager, next, jumper",
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }